var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('formio',{attrs:{"src":_vm.demoformio}}),_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{ name: 'allSubmissions' }}},[_vm._v("Todos mis submissions")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }